/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Add_ExercisesInputs */

const en_us2_plan_build_add_exercises = /** @type {(inputs: Plan_Build_Add_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add exercises`)
};

const pt_br2_plan_build_add_exercises = /** @type {(inputs: Plan_Build_Add_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar exercícios`)
};

const es_419_plan_build_add_exercises = /** @type {(inputs: Plan_Build_Add_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar ejercicios`)
};

const pt_pt2_plan_build_add_exercises = /** @type {(inputs: Plan_Build_Add_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar exercícios`)
};

const fr_fr2_plan_build_add_exercises = /** @type {(inputs: Plan_Build_Add_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des exercices`)
};

const de_de2_plan_build_add_exercises = /** @type {(inputs: Plan_Build_Add_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen hinzufügen`)
};

const it_it2_plan_build_add_exercises = /** @type {(inputs: Plan_Build_Add_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi esercizi`)
};

/**
* | output |
* | --- |
* | "Add exercises" |
*
* @param {Plan_Build_Add_ExercisesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_add_exercises = /** @type {((inputs?: Plan_Build_Add_ExercisesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Add_ExercisesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_add_exercises(inputs)
	if (locale === "es-419") return es_419_plan_build_add_exercises(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_add_exercises(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_add_exercises(inputs)
	if (locale === "de-DE") return de_de2_plan_build_add_exercises(inputs)
	if (locale === "it-IT") return it_it2_plan_build_add_exercises(inputs)
	return en_us2_plan_build_add_exercises(inputs)
});
export { plan_build_add_exercises as "plan-build.add_exercises" }